export default __webpack_public_path__ + "static/media/logo-valutamarkets.b1852e0d.png";